import React from 'react';
import { motion } from 'framer-motion';
export function LeadSection() {
  return <section className="w-full py-20 px-4 bg-brand-bg-alt border-b border-brand-card" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          <div className="flex items-center mb-8" data-id="element-84">
            <div className="h-px bg-brand-accent w-12 mr-4" data-id="element-85"></div>
            <span className="text-brand-accent font-bold tracking-widest text-sm uppercase" data-id="element-86">
              The Lead
            </span>
          </div>

          <div className="prose prose-invert prose-lg md:prose-xl max-w-none font-serif text-brand-text/90" data-id="element-87">
            <p className="first-letter:text-5xl first-letter:font-bold first-letter:text-brand-accent first-letter:float-left first-letter:mr-3 first-letter:mt-[-10px]" data-id="element-88">
              You did it. You climbed the mountain. The career is done, the 401k
              is set, and the gold watch is on your wrist. Everyone told you
              this was the "Golden Era."
            </p>

            <p data-id="element-89">
              But nobody told you about the Tuesday morning at 10:30 AM when
              you’re standing in the kitchen, and your wife asks—for the fourth
              time—why you’re loading the dishwasher like that. Or why you’re
              sitting on the sofa. Or what your "plan" is for the afternoon.
            </p>

            <p className="font-medium text-white border-l-4 border-brand-accent pl-6 py-2 my-8 bg-brand-bg/50 italic" data-id="element-90">
              Suddenly, the man who managed million-dollar budgets or led entire
              teams is being managed like a teenager on summer break.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}